import { useEffect, useState, useCallback } from 'react';
import socketService from '../services/socketService';

const useSocket = () => {
  const [isConnected, setIsConnected] = useState(false);
  
  // Connect to socket
  useEffect(() => {
    if (!socketService.isSocketConnected()) {
      socketService.connect();
    }
    
    // Update connection status
    const updateConnectionStatus = () => {
      setIsConnected(socketService.isSocketConnected());
    };
    
    // Add event listeners
    socketService.on('connect', updateConnectionStatus);
    socketService.on('disconnect', updateConnectionStatus);
    
    // Initial connection status
    updateConnectionStatus();
    
    // Cleanup on unmount
    return () => {
      socketService.off('connect', updateConnectionStatus);
      socketService.off('disconnect', updateConnectionStatus);
    };
  }, []);
  
  // Subscribe to an event
  const subscribe = useCallback((event, callback) => {
    socketService.on(event, callback);
    
    // Return cleanup function
    return () => {
      socketService.off(event, callback);
    };
  }, []);
  
  // Send an event
  const emit = useCallback((event, data) => {
    socketService.emit(event, data);
  }, []);
  
  return {
    isConnected,
    subscribe,
    emit
  };
};

export default useSocket;